import apiClient from './client';

export const searchApi = {
  strictSearch: async (params = {}) => {
    const response = await apiClient.post('/api/v1/search/strict', params);
    return response.data;
  },

  hybridSearch: async (params = {}) => {
    const response = await apiClient.post('/api/v1/search/hybrid', params);
    return response.data;
  },

  searchStatus: async () => {
    const response = await apiClient.get('/api/v1/search/status');
    return response.data;
  },

  findSimilar: async (entityType, entityId, topK = 10) => {
    const response = await apiClient.get(`/api/v1/search/similar/${entityType}/${entityId}`, {
      params: { top_k: topK }
    });
    return response.data;
  },

  agentSearch: async (params = {}) => {
    const response = await apiClient.post('/api/v1/search/agent', params, {
      timeout: 120000
    });
    return response.data;
  },
};
